import React from 'react';
import FeaturesTitle from './FeaturesTitle';
import FeaturesList from './FeaturesList';

function Features() {
  return (
    <>
      <FeaturesTitle />
      <FeaturesList />
    </>
  );
}

export default Features;
